import { OnInit, Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private stateChangeBehavior: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  stateChangeObservable: Observable<boolean> =
    this.stateChangeBehavior.asObservable();

  constructor() {}

  showSpinner() {
    this.stateChangeBehavior.next(true);
  }

  hideSpinner() {
    this.stateChangeBehavior.next(false);
  }
}
